import React from "react";

import {
  PrimaryBlockType,
  primaryBlock,
  PrimaryBlockConfig,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  renderTertiaryBlock,
  getDefaultProps,
  Shared,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box } from "theme-ui";
import defaults from "../defaults.json";
import { LayoutProps } from "../types/prop-types";

export type ItemType = {
  name: string;
  title: string;
  description: string;
  image: Shared.Props.MediaProp;
  _index?: number;
} & PrimaryBlockType<LayoutProps>;

/** ServicesItem PrimaryCollection */
export const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Medium,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockTheme: BlockTheme.light,
};

export const ContentCollectionItem = primaryBlock<ItemType>(
  { isInnerBlock: true, ...blockConfig },
  ({
    image,
    name,
    title,
    description,
    _index,
    SecondaryBlock,
    TertiaryBlock,
  }: ItemType) => {
    const isOddIndex = (_index ?? 0) % 2 !== 0;

    return (
      <Variants.GridOddEven odd={!isOddIndex} className="padding-global">
        <Box className="container-large">
          <Box className="padding-section-large">
            <Box
              className={`layout1_component${
                isOddIndex ? " mobile-reverse" : ""
              }`}
            >
              {isOddIndex && (
                <Box className="cropped-image-wrapper is--1x1-image">
                  <Variants.Image
                    src={image.url}
                    alt={image.alt}
                    className="image-w100-h100 is--cropped-image"
                  />
                </Box>
              )}
              <Box className="layout1_content">
                <Box className="margin-bottom margin-xsmall">
                  <Variants.TagLine>{name}</Variants.TagLine>
                </Box>
                <Box className="margin-bottom margin-small">
                  <Variants.Heading as="h2">{title}</Variants.Heading>
                </Box>
                <Variants.ParagraphMedium>
                  {description}
                </Variants.ParagraphMedium>
                {renderSecondaryBlock(SecondaryBlock)}
                {renderTertiaryBlock(TertiaryBlock)}
              </Box>
              {!isOddIndex && (
                <Box className="cropped-image-wrapper is--1x1-image">
                  <Variants.Image
                    src={image.url}
                    alt={image.alt}
                    className="image-w100-h100 is--cropped-image"
                  />
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Variants.GridOddEven>
    );
  }
);

ContentCollectionItem.defaultProps = getDefaultProps<ItemType>({
  layoutProps: defaults.layoutProps,
  contentProps: defaults.contentProps.PrimaryBlocks[0],
});
